import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c0e909a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style1 from "./index.vue?vue&type=style&index=1&id=1c0e909a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e909a",
  null
  
)

export default component.exports